import { create } from 'zustand';
import isEqual from 'lodash/isEqual';

export const initialLocationState = {
    address: '',
    city: '',
    city_id: '',
    district: '',
    district_id: '',
    latitude: '',
    longitude: '',
    province: '',
    province_id: '',
    subdistrict: '',
    subdistrict_id: '',
    zip_code: '',
};

export const initialChannelReport = { id: null, name: 'Toko Kelontong' };

export const useCustomerDetail = create((set, get) => ({
    initialData: null,
    formData: null,

    setInitialData: (data) => set({ initialData: data, formData: data }),

    updateFields: (updates) =>
        set((state) => ({
            formData: { ...state.formData, ...updates },
        })),

    isDirty: () => {
        const { initialData, formData } = get();
        return !isEqual(initialData, formData);
    },

    getChangedFields: () => {
        const { initialData, formData } = get();
        if (!initialData) return {};

        return Object.keys(formData).reduce((acc, key) => {
            if (!isEqual(initialData[key], formData[key])) {
                acc[key] = formData[key];
            }
            return acc;
        }, {});
    },

    resetState: () => set({ initialData: null, formData: null }),
}));
